import React from 'react';

const RetryIcon = ({ className = '', style = {}, width = 20, height = 20 }) => {
    return (
        <svg
            className={className}
            style={style}
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
        >
            <path
                d="M802.816 28.452571a46.665143 46.665143 0 0 1 51.492571 33.938286l1.170286 5.778286 28.745143 204.288-6.217143 8.265143-204.361143 28.745143a46.665143 46.665143 0 0 1-18.285714-91.428572l5.339429-1.024 61.147428-8.630857-2.048-0.950857L716.068571 204.8a366.226286 366.226286 0 0 0-164.937142-59.538286l-19.968-1.609143A368.566857 368.566857 0 1 0 879.908571 531.017143a46.957714 46.957714 0 0 1 93.769143 4.900571 462.409143 462.409143 0 1 1-200.996571-406.162285l-3.072-1.974858-6.582857-46.592a46.665143 46.665143 0 0 1 27.794285-49.371428l6.656-2.340572z"
                fill="#258FFF"
            />
        </svg>
    );
};

export default RetryIcon;

